module.exports = __webpack_public_path__ + "static/media/vaccine-program-image.5622ec84.png";